import * as z from 'zod';
import { cloudStorageBucketNameSchema, fileExtensionSchema, classificationPredictionSchema, fileTypeSchema } from '../../enums.mjs';
import { fileId } from '../../types/opaque.mjs';

var Classify;
(function (Classify) {
    (function (Request) {
        Request.schema = z.object({
            fileId: fileId,
            fileName: z.string(),
            fileExtension: fileExtensionSchema,
            bucket: cloudStorageBucketNameSchema,
            bucketDirPath: z.array(z.string()).optional(),
        });
    })(Classify.Request || (Classify.Request = {}));
})(Classify || (Classify = {}));
const classifyDeferReasonSchema = z.enum([
    "scanned",
    "not_confident",
    "other",
    "unsupported",
    "ocr_error",
    "ml_error",
    "unavailable",
]);
var ClassifySync;
(function (ClassifySync) {
    (function (Request) {
        Request.schema = Classify.Request.schema;
    })(ClassifySync.Request || (ClassifySync.Request = {}));
    (function (Response) {
        const classifiedSchema = z.object({
            status: z.literal("classified"),
            tags: z.array(fileTypeSchema),
            prediction: classificationPredictionSchema.optional(),
        });
        const deferredSchema = z.object({
            status: z.literal("deferred"),
            reason: classifyDeferReasonSchema,
        });
        Response.schema = z.discriminatedUnion("status", [classifiedSchema, deferredSchema]);
    })(ClassifySync.Response || (ClassifySync.Response = {}));
})(ClassifySync || (ClassifySync = {}));

export { Classify, ClassifySync, classifyDeferReasonSchema };
